import instructionalPart1Description from '../content/instructionalPart1';

import { unemployabilityTitle } from '../content/unemployabilityFormIntro';

export const uiSchema = {
  'ui:title': unemployabilityTitle,
  'ui:description': instructionalPart1Description,
};

export const schema = {
  type: 'object',
  properties: {},
};
